import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useLocalization } from '../../../hooks/useLocalization';

import { FETCH_CLIENT_REPORT_TEMPLATE_NAME } from './clientReportTemplateBreadcrumb.query';

export function ClientReportTemplateBreadcrumb(): string {
  const { translateBackendString } = useLocalization();
  const { id } = useParams();
  const { data } = useQuery(FETCH_CLIENT_REPORT_TEMPLATE_NAME, {
    variables: { id: id! },
    skip: !id,
  });
  const { t } = useTranslation();
  const templateName = data?.fetchClientReportTemplate?.clientReportTemplate
    ? translateBackendString(
        data.fetchClientReportTemplate.clientReportTemplate.translatedName,
      )
    : '';

  return t('clientReportTemplate:nameTemplate', { name: templateName });
}
